export default function InfoContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col rounded-2xl bg-white px-4 py-5 md:px-8 dark:bg-slate-700">
      {children}
    </div>
  );
}
